import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import ModalOverlay from './../ModalOverlay.jsx';
import { MediaContext } from '../../MediaContext';
import './ComposableVideo.css';
import YouTubeVideo from './YoutubeVideo.jsx';

const isYoutubeUrl = 'youtube.com';

const ComposableVideo = ({ mediaContext, src, style }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const { setIsVideoPlaying } = useContext(MediaContext);
   
    useEffect(() => { 
        setIsVideoPlaying(true);
        return (() => {
            setIsVideoPlaying(false);
        });
    }, []);

    const onPlay = () => {
        setIsPlaying(true);
    };

    const onPause = () => {
        setIsPlaying(false);
    };

    const onStartLoad = () => {
        setIsLoading(true)
    }

    const onEndLoad = () => {
        setIsLoading(false)
    }

    return (
        <div className={isPlaying ? 'composableVideoPlaying' : 'youtube-iframe-container'}>
            <ModalOverlay />
            {src.includes(isYoutubeUrl) ? 
                // <iframe width="100%" height="100%" src={src+'?autoplay=1'} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                <YouTubeVideo  id={src}/>
            :
            <video
                controls
                autoPlay
                preload='auto'
                style={style}
                onPlay={onPlay}
                onPause={onPause}
                onLoadStart={onStartLoad}
                onLoadedData={onEndLoad}
                width={isLoading ? '0' : 'auto'}
            >
                <source src={src} />
            </video>
        }
        </div>
    );
}

ComposableVideo.propTypes = {
    src: PropTypes.string.isRequired,
    style: PropTypes.object
};

export default props => (
    <MediaContext.Consumer>
        {mediaContextValue => (
            <ComposableVideo
                mediaContext={mediaContextValue}
                {...props}
            />
        )}
    </MediaContext.Consumer>
)

